import { render, staticRenderFns } from "./PettyCashDimensions.vue?vue&type=template&id=3b36c2cd"
import script from "./PettyCashDimensions.vue?vue&type=script&lang=js"
export * from "./PettyCashDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports